module.exports = __webpack_public_path__ + "static/media/scanaenergy.faebceb7.png";